import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';

import {useEventTracking} from 'src/hooks/useEventTracking';

import Button from '@pb/kit-component-button';
import {Group} from '@pb/kit-component-group';

import {errorPage, errorPageSmallError, errorPageSubtitle, errorPageTitle} from './error-page.component.module.styl';

type Props = {
    title: string,
    subtitle: string,
    handler?: string,
    secondaryButton?: React.ReactNode,
    primaryButton?: React.ReactNode,
    small?: boolean,
};


export const ErrorPage = (props: Props) => {
    const {searchCriteriaOpen} = useEventTracking();
    const navigate = useNavigate();

    const onClick = useCallback(() => {
        const handler = props.handler || '/';

        if (!props.primaryButton && handler === '/') {
            searchCriteriaOpen({
                place: props.title,
            });
            navigate(handler);
        }
    }, [props.primaryButton, props.title, props.handler, navigate, searchCriteriaOpen]);

    return (
        <ErrorPageView {...{...props, handler: onClick}}/>
    );
};

const ErrorPageView = (props: Omit<Props, 'handler'> & {handler: () => void}) => {
    const {title, subtitle, secondaryButton, handler, primaryButton} = props;

    const clearCacheButton = (
        <Button
            variant="Type.TERTIARY"
            onClick={() => {
                localStorage.clear();
                window.location.reload();
            }}>
            Clear Cache
        </Button>
    );

    return !props.small ? (
        <div className={errorPage}>
            <div className={errorPageTitle}>
                {title}
            </div>
            <div className={errorPageSubtitle}>
                {subtitle}
            </div>
            <Group alignItems="start" justify="center">
                {primaryButton || <Button variant="Type.PRIMARY" onClick={handler}>Home</Button>}
                {secondaryButton}
                {clearCacheButton}
            </Group>
        </div>
    ) : (
        <Group direction="v" alignItems="center" className={errorPageSmallError}>
            <div className={errorPageTitle}>
                {title}
            </div>
            <div className={errorPageSubtitle}>
                {subtitle}
            </div>
            <Group alignItems="start" justify="center">
                {primaryButton}
                {secondaryButton}
                {clearCacheButton}
            </Group>
        </Group>
    );
};
